var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonPink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_198",
    "data-name": "Group 198",
    transform: "translate(14125.5 339.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_230",
    "data-name": "Rectangle 230",
    width: 25,
    height: 25,
    transform: "translate(-14125.5 -339.5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(-14125.333 -339)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_229",
    "data-name": "Rectangle 229",
    width: 24,
    height: 24,
    transform: "translate(0.333)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    d: "M-1.156-8A6.852,6.852,0,0,1,5.688-1.156,6.852,6.852,0,0,1-1.156,5.688,6.852,6.852,0,0,1-8-1.156,6.852,6.852,0,0,1-1.156-8Zm0,12.167A5.329,5.329,0,0,0,4.167-1.156,5.329,5.329,0,0,0-1.156-6.479,5.329,5.329,0,0,0-6.479-1.156,5.329,5.329,0,0,0-1.156,4.167Z",
    transform: "translate(13.323 10.281)",
    fill: "#e7b1ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M42.2,158.836a.76.76,0,0,1-.659-.38,9.885,9.885,0,0,0-17.123,0,.76.76,0,1,1-1.317-.76,11.406,11.406,0,0,1,19.757,0,.761.761,0,0,1-.658,1.141Z",
    transform: "translate(-20.813 -137.544)",
    fill: "#e7b1ad"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonPink);
export default __webpack_public_path__ + "static/media/person_pink.bce8f9c926602733845109c95dcce7ba.svg";
export { ForwardRef as ReactComponent };